<span class={`main-line-ply ${color}-move empty`}> ... </span>

<script lang="ts">
export let color: 'white' | 'black';
</script>
